import { Component, OnInit, Input } from '@angular/core';
import { transition, style, animate, trigger } from '@angular/animations';

const enterTransition = transition(':enter', [
  style({
    opacity: 0
  }),
  animate('1s ease-in', style({
    opacity: 1
  }))
]);

const leaveTrans = transition(':leave', [
  style({
    opacity: 1
  }),
  animate('1s ease-out', style({
    opacity: 0
  }))
])

const fadeIn = trigger('fadeIn', [
  enterTransition
]);

const fadeOut = trigger('fadeOut', [
  leaveTrans
]);


@Component({
  selector: 'app-response-text',
  templateUrl: './response-text.component.html',
  styleUrls: ['./response-text.component.css'],
  animations: [
    fadeIn,
    fadeOut
  ]
})
export class ResponseTextComponent implements OnInit {

  @Input() lambdaError: boolean = false;
  @Input() lambdaMessage: string = '';
  @Input() messageTime: number = 8;
  show = false;
  interval;
  constructor() { }

  ngOnInit(): void {
  }
  ngOnChanges(changes): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    this.show = true;
    this.startAnimationTimer();
  }
  startAnimationTimer(){
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      if(this.show && !this.lambdaError){
        this.show = false;
      }
    }, this.messageTime * 1000);
  }
}
